import React, { useMemo } from 'react';
import { channelInfo } from '@/pages/opinion/components/ChannelLabel';
import RenderImg from '@op/components/RenderImg';
import { dealwithBiLiBiLiImage } from '@op/utils/cdnUrl';
import { getFeedsContentText } from '@op/utils/languageValue';
import { duration } from '@/pages/opinion/utils/time';
import { keywordRenderFunc } from '@op/utils/text';
import moment from 'moment';
import { transLanguage } from '@/pages/opinion/utils';
import { Bubble } from 'tea-component';
import SvgIcon from '@home/components/SvgIcon';
import './index.scss';
import { buriedCommonBtnPoint } from '@op/operationLog/buriedPoint';
import { goToFeedsReviewsDetail } from '@op/utils/url';
import { useHistory } from 'umi';
import classnames from 'classnames';
import { DefaultImg } from '@op/constants/defaultImg';

export default function VideoBox(props: any) {
  const {
    formatMessage,
    language,
    // wholeGameInfo,
    keyword,
    records,
    logBtnId,
    commonComp = 'table',
    gameInfo,
    gameMap,
    hasDetailPage = true,
  } = props;
  const history = useHistory();

  // For multi-game: gameMap key (game_id) matches records.unified_id
  const resolvedGameInfo = useMemo(() => {
    if (!gameMap) return gameInfo;
    const matched = gameMap.get(records.unified_id);
    return matched ? { ...matched, edition_unified_id: records.unified_id } : undefined;
  }, [gameMap, gameInfo, records.unified_id]);

  if (!records) return null;

  const channel = channelInfo(records.channel_name);
  const videoInfo = { cover_image: '', duration: '', url: '' };
  try {
    const obj = JSON.parse(records.video_detail);
    // 判断是否是B站图片
    obj.cover_image = dealwithBiLiBiLiImage(obj.cover_image);
    Object.assign(videoInfo, obj);
  } catch (error) { }

  const getContentText = () => {
    const value = getFeedsContentText(records, language);

    return value.length > 80 ? (
      <div style={{ whiteSpace: 'pre-wrap' }}>{value}</div>
    ) : null;
  };

  const openVideoPage = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    comment_url: string | URL | undefined,
  ) => {
    if (!comment_url) return;
    buriedCommonBtnPoint(commonComp, logBtnId, 'GoToURL', records.comment_uin);
    window.open(comment_url);
    event.stopPropagation();
  };

  const renderDuration = (durationStr: string) => {
    let curDurationStr = durationStr;
    if (/^(\d+)s*$/i.test(durationStr)) {
      curDurationStr = duration(Number(String(durationStr).replace(/s/gi, '')));
    }
    return curDurationStr;
  };

  const renderContent = (records: any) =>
    keywordRenderFunc({
      text: getFeedsContentText(records, language),
      keyword,
    });

  return (
    <a
      className="dbo-trending-videobox-wrapper"
      onClick={(e) => e.preventDefault()}
      href={records.content_url}
    >
      <div className="dbo-trending-videobox">
        <div className="dbo-trending-videobox-coverbox">
          {/* <img
            src={wholeGameInfo?.entity_image}
            className="dbo-trending-videobox-cover"
            style={{
              zIndex: 1,
              position: 'absolute',
            }}
          ></img> */}

          <RenderImg
            className="dbo-trending-videobox-cover"
            coverImage={videoInfo.cover_image}
            defaultImage={DefaultImg.VIDEO}
            style={{
              zIndex: 2,
              position: 'relative',
            }}
            aigc={records?.aigc === 1}
          ></RenderImg>

          {videoInfo.duration && (
            <span className="dbo-trending-videobox-time">
              {renderDuration(videoInfo.duration)}
            </span>
          )}
        </div>
        <div className="dbo-trending-videobox-infobox">
          <Bubble
            dark
            placement="top"
            content={getContentText()}
            trigger={'click'}
            overlayClassName="dbo-trending-videobox-bubble"
          >
            <span
              className={classnames('dbo-trending-videobox-title', {
                'dbo-active': hasDetailPage,
              })}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (!hasDetailPage) return;
                if (logBtnId) {
                  buriedCommonBtnPoint(
                    commonComp,
                    logBtnId,
                    'ClickCard',
                    records.comment_uin,
                  );
                }
                goToFeedsReviewsDetail(
                  history,
                  records,
                  resolvedGameInfo?.edition_unified_id
                    ? { language, gameid: resolvedGameInfo?.edition_unified_id }
                    : { language },
                );
              }}
            >
              {renderContent(records)}
            </span>
          </Bubble>

          <Bubble
            dark
            placement="top"
            content={formatMessage({ id: 'Go to original post' })}
          >
            <div
              className="dbo-trending-videobox-share"
              onClick={(event) => {
                openVideoPage(event, records.content_url);
                event.preventDefault();
              }}
            >
              <SvgIcon type="other-share-icon" className="dbo-feeds-btn-icon" />
            </div>
          </Bubble>
          <div className='dbo-trending-videobox-game-source'>
            {
              gameMap && (
                <div className="dbo-trending-videobox-game">
                  <RenderImg
                    coverImage={resolvedGameInfo?.cover}
                    className="dbo-trending-videobox-game__icon"
                  />
                  <span className="dbo-trending-videobox-game__name">
                    {resolvedGameInfo?.name}
                  </span>
                </div>
              )
            }
            <div className="dbo-trending-videobox-source">
              <img
                className="dbo-trending-videobox-source-icon"
                src={channel.img}
              />
              <span className="dbo-trending-videobox-text">
                {records.reviewer}
              </span>
            </div>
          </div>

          <div className="dbo-trending-videobox-des">
            <span className="dbo-trending-videobox-text">
              {moment(records.comment_time).format('YYYY-MM-DD HH:mm')}
            </span>
            <span className="dbo-trending-videobox-text">
              {transLanguage(records.language)}
            </span>
            {/* AI Generated Tag */}
          </div>
        </div>
      </div>
    </a>
  );
}
